"use client";

import { Grid2 } from "@repo/ui";
import Section from "../components/Section";
import NewsMediaCard from "../components/NewsMediaCard";
import LoadMore from "@/components/LoadMore";
interface OlderNewsProps {
  data?: MediaInterface[];
}
const OlderNews = ({ data = [] }: OlderNewsProps) => {
  return (
    <Section title="Older News">
      <LoadMore
        wrapper={<Grid2 container spacing={5} />}
        initialVisibleItems={6}
        items={data || []}
        render={(media, index) => (
          <Grid2
            key={`oldest-news-${index}`}
            size={{ xs: 12, sm: 6, md: 4, lg: 4 }}
          >
            <NewsMediaCard
              description={media.description}
              logo={media.media_logo}
              mediaUrl={media.media_url}
              readingTime={media.reading_time}
              publishAt={media.publish_at}
              headline={media.headline}
            />
          </Grid2>
        )}
      />
    </Section>
  );
};

export default OlderNews;
